import { IAuthorizationPolicyDocument } from "@/models/policy";
import { ModelValidation } from "@/models/modelvalidation";

export interface IServiceAccount {
    uuid?: string | null;
    serviceProviderId?: string | null;
    serviceProviderName?: string | null;
    contentProviderId?: string | null;
    contentProviderName?: string | null;
    role?: string | null;
    name?: string | null;
    description?: string | null;
    authorizationPolicyUuid?: string | null;
    //policySetup?: IAuthorizationPolicyDocument;
}

export class ServiceAccount extends ModelValidation {
    public uuid!: string | null;
    public serviceProviderId!: string | null;
    public serviceProviderName!: string | null;
    public contentProviderId!: string | null;
    public contentProviderName!: string | null;
    public role!: string | null;
    public name!: string | null;
    public description!: string | null;
    public authorizationPolicyUuid!: string | null;
    //public policySetup!: IAuthorizationPolicyDocument;

    constructor(user: IServiceAccount | any) {
        super();
        
        if (!user) {
            throw new Error("Cannot construct User from falsey IServiceAccount");
        }

        this.uuid = user.uuid;
        this.serviceProviderId = user.serviceProviderId;
        this.serviceProviderName = user.serviceProviderName;
        this.contentProviderId = user.contentProviderId;
        this.contentProviderName = user.contentProviderName;
        this.role = user.role;
        this.name = user.name;
        this.description = user.description;
        this.authorizationPolicyUuid = user.authorizationPolicyUuid;
        //this.policySetup = user.policySetup;
    }

    public static empty(): ServiceAccount {
        return new ServiceAccount({});
    }

    public toNewServiceAccountDto(): IServiceAccount | any {
        return {
            role: this.role,
            name: this.name,
            description: this.description
        };
    }

    public toUpdateServiceAccountDto(): IServiceAccount {
        // these wind up being the same implementation but are semantically different
        const result = this.toNewServiceAccountDto();
        result.uuid = this.uuid;
        return result;
    }
}
